import { __assign, __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var mobileCta = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 84 81", fill: "currentColor", width: size || "1em", height: size || "1em" }, props),
        React.createElement("g", { id: "noun_chat_860090", fill: "currentColor", fillRule: "nonzero" },
            React.createElement("path", { d: "M72.2,0.5 L11.8,0.5 C5.6,0.5 0.6,5.5 0.6,11.7 L0.6,52.4 C0.6,58.6 5.6,63.6 11.8,63.6 L16.4,63.6 L16.4,80.1 L36,63.6 L72.3,63.6 C78.5,63.6 83.5,58.6 83.5,52.4 L83.5,11.7 C83.4,5.5 78.4,0.5 72.2,0.5 Z", id: "Path" }))));
};
mobileCta.displayName = 'mobileCta';
export default mobileCta;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=mobileCta.js.map